import { useEffect } from "react";

import { type DocObj } from "@hsl/fund-explorer/types";

import { LanguageList } from "./LanguageList";

export const DocDisplayPanel = ({
    data,
    top,
    left,
    className,
    close,
}: {
    data: DocObj[];
    top: number;
    left: number;
    className?: string;
    close(): void;
}) => {
    useEffect(() => {
        const onScroll = () => close();
        window.addEventListener("scroll", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    return (
        <LanguageList
            docArr={data}
            style={{ top, left }}
            className={className}
        />
    );
};
